
export interface AnnouncementData {
    id: number;
    subject: string;
    moreInfo: string;
    buttons: AnnouncementButton[];
    type: AnnouncementType;
}

export enum AnnouncementType {
    Notice = 'notice',
    Important = 'important',
    Promotion = 'promotion'
}

export interface AnnouncementButton {
    id: number;
    label: string;
    actionType: AnnouncementButtonActionType;
    payload: string;
    announcementId: number;
}

export enum AnnouncementButtonActionType {
    ReadMore = 'read-more',
    Copy = 'copy',
    LinkExternal = 'link-external',
    LinkInternal = 'link-internal'
}
